import { ActionType } from '../helpers/constants'

const INTIAL_STATE = {
    loading: true,
    conversationId: null,
    userId: null,
    messages: [],
    isActive: false,
    isChatOffline: false,
    isChatReconnecting: false,
    joinedRoom: false,
    pagination: {
        isLast: false,
        page: 1,
        pageSize: 10
    },
};

export function privateChats(state = INTIAL_STATE, { type, payload }) {
    switch (type) {
        case ActionType.PRIVATE_CHATS_GET:
            return {
                ...state,
                conversationId: payload.conversationId,
                messages: [...state.messages, ...payload.messages],
                pagination: {
                    isLast: payload.isLast,
                    page: payload.page,
                    pages: payload.pages,
                    total: payload.total,
                    pageSize: state.pagination.pageSize,
                },
                loading: false,
            };

        case ActionType.LOAD_PREVIOUS_PRIVATE_MESSAGES:
            return {
                ...state,
                conversationId: payload.conversationId,
                messages: [...payload.messages],
                pagination: {
                    isLast: payload.isLast,
                    page: payload.page,
                    pages: payload.pages,
                    total: payload.total,
                    pageSize: state.pagination.pageSize,
                },
                loading: false,
            };
        case ActionType.SEND_PRIVATE_MESSAGE:
            return {
                ...state,
                messages: [payload, ...state.messages],
            };
        case ActionType.PRIVATE_JOINED_ROOM:
            return {
                ...state,
                userId: payload,
                joinedRoom: true,
            };
        case ActionType.PRIVATE_CHAT_LOADER:
            return {
                ...state,
                loading: payload,
            };

        case ActionType.CLEAR_PRIVATE_CHATS_GET:
            return INTIAL_STATE

        case ActionType.SET_PRIVATE_CHAT_ACTIVE:
            return {
                ...state,
                isActive: payload,
            };
        case ActionType.SET_PRIVATE_CHAT_OFFLINE:
            return {
                ...state,
                isChatOffline: payload,
            };

        case ActionType.SET_PRIVATE_CHAT_RECONNECTING:
            return {
                ...state,
                isChatReconnecting: payload,
            };

        default:
            return state
    }
}



